import axios from 'axios';
import { BASE_API, USER_TOKEN } from 'config/consts';
import moment from 'moment';
import type from './types';

const URL = `${BASE_API}/partner-subscription`;
const URL_REWARD_PRESENTIAL_COURSE = `${BASE_API}/reward-presential-course`;
const URL_CANCEL_PRESENTIAL_COURSE_SUBSCRIPTION = `${BASE_API}/cancel-presential-course-subscription`;

export const getList = id => {
  return dispatch => {
    dispatch({ type: type.SUBSCRIPTIONS_LOAD, payload: true });
    axios
      .get(`${URL}/${id}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then(response => {
        response.data.forEach(item => {
          item['validated'] = parseInt(item.validated) === 0 ? 'Não' : 'Sim';
          item['createdAt'] = moment(item.createdAt).format('DD/MM/YYYY HH:mm');
        });
        dispatch([
          {
            type: type.SUBSCRIPTIONS_FETCHED,
            payload: response,
          },
        ]);
      });
  };
};

export const getValidatedList = id => {
  return dispatch => {
    dispatch({ type: type.SUBSCRIPTIONS_LOAD, payload: true });
    axios
      .get(`${URL}/${id}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then(response => {
        const modifiedResponse = response.data.filter(
          item =>
            parseInt(item.validated) === 1 && !(item.cancelled || item.paid)
        );
        modifiedResponse.forEach(item => {
          item['validated'] = parseInt(item.validated) === 0 ? 'Não' : 'Sim';
          item['createdAt'] = moment(item.createdAt).format('DD/MM/YYYY HH:mm');
        });

        dispatch([
          {
            type: type.SUBSCRIPTIONS_FETCHED,
            payload: { data: modifiedResponse },
          },
        ]);
      });
  };
};

export const rewardPresentialCourse = data => {
  return dispatch => {
    dispatch({ type: type.SUBSCRIPTIONS_REWARD_LOAD, payload: true });
    axios
      .put(
        `${URL_REWARD_PRESENTIAL_COURSE}/${data.id}`,
        {},
        {
          headers: {
            Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
          },
        }
      )
      .then(response => {
        dispatch([
          {
            type: type.SUBSCRIPTIONS_REWARD_MODAL,
            payload: false,
          },
          { type: type.SUBSCRIPTIONS_REWARD_LOAD, payload: false },
          getValidatedList(data.presential_course.partner_id),
        ]);
      });
  };
};

export const cancelPresentialCourseSubscription = data => {
  return dispatch => {
    dispatch({ type: type.SUBSCRIPTIONS_REWARD_LOAD, payload: true });
    axios
      .put(
        `${URL_CANCEL_PRESENTIAL_COURSE_SUBSCRIPTION}/${data.id}`,
        {},
        {
          headers: {
            Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
          },
        }
      )
      .then(response => {
        dispatch([
          {
            type: type.SUBSCRIPTIONS_CANCEL_MODAL,
            payload: false,
          },
          { type: type.SUBSCRIPTIONS_REWARD_LOAD, payload: false },
          getValidatedList(data.presential_course.partner_id),
        ]);
      })
      .catch(e => {
        dispatch([
          {
            type: 'SNACKBAR',
            payload: {
              message: e.response.data.error,
              variant: 'error',
              open: true,
            },
          },
          { type: type.SUBSCRIPTIONS_REWARD_LOAD, payload: false },
        ]);
      });
  };
};

export const setSubscriptionRewardLoading = status => {
  return dispatch => {
    dispatch({ type: type.SUBSCRIPTIONS_REWARD_LOAD, payload: status });
  };
};

export const setSubscriptionRewardModal = status => {
  return dispatch => {
    dispatch({ type: type.SUBSCRIPTIONS_REWARD_MODAL, payload: status });
  };
};

export const setSubscriptionCancelModal = status => {
  return dispatch => {
    dispatch({ type: type.SUBSCRIPTIONS_CANCEL_MODAL, payload: status });
  };
};
